import { AccountType } from '../account/account-type';
import { Address } from '../common/address';
import { Avatar } from '../common/avatar';
import { Company } from '../common/company';
import { DistanceUnit } from '../common/distance-unit';
import { Identifier } from '../common/identifier';
import { ListGroupBy } from '../common/list-group-by';

export class User implements Avatar, Identifier {
    public id: string;
    public type?: string; // user
    public name: string;
    public first_name?: string;
    public last_name?: string;
    public phone?: string;
    public email?: string;
    public email_pending?: string;
    public avatar_url: string;
    public profile_type: AccountType;
    public privacy: string;
    public description: string;
    public default_radius: number;
    public distance_unit: DistanceUnit;
    public locale: string; // en-US
    public timezone: string; // UTC
    public datetime_format: number;
    public onboard: boolean;
    public lat: number;
    public lng: number;
    public start_day_of_week: number;
    public start_time_of_day: string;
    public appear_in_job_search: boolean;
    public appear_in_shift_search: boolean;
    public appear_in_map_search: boolean;
    public auto_swap_approval: boolean;
    public allow_shift_swaps: boolean;
    public allow_chat: boolean;
    public allow_offsites: boolean;
    public shift_change_cutoff: number;
    public reserved_enabled: boolean;
    public updated_at: string; // "2017-06-30 09:47:03",
    public recommendations_count: number;
    public skills_count: number;
    public gallery_count: number;
    public groups: string;
    public address: Address;
    public companies: any[];
    public skills: any[];
    public paygroups: any[];
    public product_usage: { attendance: number; compliance: number };
    public company: Company;
    public selected?: boolean;
    public currency: string;

    constructor() {}

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        return '';
    }
}
